export enum SDKBrower {
  WeChat = "wechat",
  Alipay = "alipay",
  QQ = "qq",
  Quark = "quark",
  Douyin = "douyin",
  Weibo = "weibo",
  Unknown = "unknown",
}
